import React, { useEffect } from 'react'
import { App, URLOpenListenerEvent } from '@capacitor/app'

// Keeping for debugging intents later. Remove / Debug before release
async function LogState(event: URLOpenListenerEvent) {
  console.log('Launch Event: ')
  console.log(event)
}

const AppUrlListener: React.FC<{ callback: (slug: string, url: string) => Promise<void> }> = ({
  callback,
}) => {
  useEffect(() => {
    App.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
      await LogState(event)
      callback('nothing', event.url)
    })

    return () => {
      App.removeAllListeners()
    }
  }, [])

  return null
}

export default AppUrlListener
